import React from 'react'
import {Grid, Container, Box} from '@material-ui/core'
import TabsContainer from '../containers/TabsContainer'
import SwitchViews from '../containers/SwitchViews'
import { viewStyles } from '../styles/styles'

const Settings = ({tab}) => {
    const classes = viewStyles()
    return (
        <Container>
            <Grid container>
                <Grid item xs={12}>
                    <Box m="20px 0 0 0">
                        <TabsContainer tab={tab}></TabsContainer>
                    </Box>                    
                </Grid>
                <Grid item xs={12}>
                    <Box className={classes.box_settings}>
                        <SwitchViews></SwitchViews>
                    </Box>
                </Grid>
            </Grid>
        </Container>
        
    )
}

export default Settings;